import { render } from "./FileRanking.vue?vue&type=template&id=024c11fd&ts=true"
import script from "./FileRanking.vue?vue&type=script&lang=ts"
export * from "./FileRanking.vue?vue&type=script&lang=ts"

import "./FileRanking.vue?vue&type=style&index=0&id=024c11fd&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__